export const addresses = {
  addresses: 'Mis direcciones',
  noAddresses: 'No hay direcciones asociadas.',
  addAddress: 'Agregar dirección',
  edit: 'Editar',
  remove: 'Borrar',
  mainAddress: 'Dirección Principal',
  editDialog: {
    editAddress: 'Editar dirección',
    labelAddress: 'Dirección',
    labelFloor: 'Piso',
    labelApartment: 'Departamento',
    accept: 'Aceptar',
    cancel: 'Cancel',
  },
  removeDialog: {
    removeAddress: 'Borrar dirección',
    areYouSure: '¿Está seguro de que desea borrar esta dirección?',
    accept: 'Aceptar',
    cancel: 'Cancel',
  },
  addDialog: {
    addAddress: 'Agregar dirección',
    labelAddress: 'Dirección',
    labelNumber: 'Número',
    labelPostalCode: 'Código Postal',
    labelFloor: 'Piso',
    labelApartment: 'Departamento',
    accept: 'Aceptar',
    cancel: 'Cancel',
  },
  completeAddress: 'Completá la dirección',
  noStreetNumber: 'Completá el número de la calle',
  noPostalCode: 'Completá el código postal.',
  editSuccess: 'Dirección editada exitosamente',
  addSuccess: 'Dirección agregada exitosamente',
  removeSuccess: 'Dirección borrada exitosamente',
}

export const changeEmail = {
  codeSent: 'Código enviado',
  changeEmail: 'Modificar e-mail',
  body: 'Para modificar tu dirección de e-mail ingresá el nuevo en el campo de abajo. Un código de verificación será enviado a la nueva dirección, junto con instrucciones sobre cómo seguir.',
  email: 'E-mail',
  sendCode: 'Enviar código',
}

export const changePassword = {
  passwordsDoNotMatch: 'Las contraseñas no coinciden',
  passwordChangeSuccess: 'Contraseña cambiada exitosamente',
  changePassword: 'Cambiar contraseña',
  body: 'Por tu seguridad, ingresá primero tu contraseña actual, y luego la nueva contraseña. O ',
  iForgotMyPassword: 'recuperá tu contraseña.',
  labelCurrentPassword: 'Contraseña actual',
  labelNewPassword: 'Nueva contraseña',
  repeatPassword: 'Confirmar contraseña',
  save: 'Guardar',
  cancel: 'Cancelar',
}

export const changePhone = {
  codeSent: 'Código enviado',
  phoneChangeSuccess: 'Número de teléfono cambiado exitosamente',
  changePhone: 'Modificar número de teléfono',
  body: 'Para modificar tu número de teléfono, ingresá el nuevo en el campo de abajo. Un código de verificación será enviado al nuevo número.',
  labelPhoneNumber: 'Número de teléfono',
  iHaveACode: 'Ya tengo un código',
  sendCode: 'Enviar Código',
  dialog: {
    title: 'Código',
    body: 'Ingresá el código recibido por mensaje de texto. Si no lo recibiste en 5 minutos, podés reintentar.',
    labelPhoneNumber: 'Número de teléfono',
    labelCode: 'Código',
    cancel: 'Cancelar',
    sendAnotherCode: 'Enviar código',
    accept: 'Continuar',
  },
}

export const profileBasic = {
  saveSuccess: 'Datos guardados exitosamente',
  pictureSavedSuccess: 'Foto guardada exitosamente',
  basicInformation: 'Información básica',
  labelName: 'Nombre',
  labelLastName: 'Apellido',
  labelEmail: 'Email',
  labelPhoneNumber: 'Número de teléfono',
  save: 'Guardar',
  profilePicture: 'Foto de perfil',
  pictureBody: 'Arrastrá una foto o hacé click en este cuadro',
  modifyPassword: 'Modificar contraseña',
  modifyPhone: 'Modificar',
  cancel: 'Cancelar',
  accept: 'Aceptar',
}

export const paymentMethod = {
  actions: {
    numberInvalid: 'Número inválido',
    expiryInvalid: 'Fecha de vencimiento inválida',
    cvcInvalid: 'Código de seguridad inválido',
    addSuccess: 'Tarjeta agregada exitosamente',
    removeSuccess: 'Tarjeta borrada exitosamente',
    markSuccess: 'Tarjeta modificada exitosamente',
  },
  noCards: 'No hay tarjetas asociadas.',
  mainCardText: 'Los pagos del depósito se realizan aquí ',
  mainCardAction: 'cambiar',
  expiryDate: 'Vto',
  add: 'Agregar tarjeta',
  addDialog: {
    title: 'Agregar tarjeta de crédito',
    cancel: 'Cancelar',
    accept: 'Guardar',
  },
  removeDialog: {
    title: 'Borrar tarjeta',
    areYouSure: '¿Está seguro de que desea borrar esta tarjeta?',
    cancel: 'Cancelar',
    accept: 'Aceptar',
  },
  markDialog: {
    title: 'Elegir tarjeta',
    body: 'En esta tarjeta se realizarán los pagos del depósito',
    cancel: 'Cancelar',
    accept: 'Aceptar',
  },
  emptyList: {
    body1: 'No tienes ninguna tarjeta definida para tus pagos',
    body2: 'No te preocupes, no haremos ningún cargo sin tu permiso',
    button: 'Agregar tarjeta de crédito',
  }
}



// WEBPACK FOOTER //
// ./src/sections/profile/text.js